import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { HydraTable, Heading, TextFilter } from "@peracto/peracto-ui";

import { GET_LIST, useClient } from "@peracto/client";

import dayjs from "dayjs";

export const DigitalReturnsList = () => {
  // Default visible columns - key = column accessor
  const [selectedColumns, onSelectColumn] = useState();

  const { client } = useClient();

  const tableColumns = [
    {
      Header: "Order Number",
      accessor: "orderNumber",
      sortType: "basic",
      disableSorting: true,

      Filter: (props) => <TextFilter label="Order Number" {...props} />,
      Cell: (row) => (
        <Link to={`${row.row.original.id}`}>{row.cell.value || "-"}</Link>
      ),
      selectable: false,
    },
    {
      Header: "Email",
      accessor: "email",
      sortType: "basic",
      disableSorting: true,

      Filter: (props) => <TextFilter label="Email" {...props} />,
      selectable: false,
    },
    {
      Header: "Return Created",
      accessor: "createdAt",
      sortType: "none",
      disableSorting: true,
      disableFilters: true,
      Cell: ({ cell: { value } }) =>
        new Date(value) > 0 ? dayjs(value).format("DD MMM YYYY HH:mm:ss") : "-",
      selectable: false,
    },
  ];

  // The 'selectable' property is used to define if the
  // column is available in the 'manage columns' dropdown
  const columns = useMemo(() => tableColumns, [tableColumns]);
  const onFetchData = (options) => {
    if (options?.filter) {
      const { orderNumber, email, ...restFilters } = options.filter;
      options = {
        ...options,
        filter: {
          ...restFilters,
          ...(orderNumber && { "order.reference": orderNumber }),
          ...(email && { "user.email": email }),
        },
      };
    }

    return client(GET_LIST, "digital-returns", {
      ...options,
      id: "digital-returns",
    });
  };

  return (
    <>
      <Helmet>
        <title>Returns | Peracto</title>
      </Helmet>
      <Heading name="Returns" />

      <div className="row">
        <div className="col">
          <div className="card card--transparent">
            <div className="card-body">
              <HydraTable
                columns={columns}
                selectedColumns={selectedColumns}
                onFetchData={onFetchData}
                onSelectColumn={onSelectColumn}
                defaultFilters={{
                  orderNumber: "",
                  email: "",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DigitalReturnsList;
